// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"task-add"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8 6V4H4V22H11M8 6H16M8 6V2H16V6M16 6V4H20V11","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M19 15V19M19 19V23M19 19H15M19 19H23","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TaskAddIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'task-add',
    ref,
    icon: element,
  },
));

TaskAddIcon.displayName = 'TaskAddIcon';

export default TaskAddIcon;
